import PropTypes from 'prop-types';
import React from 'react';

import { ArrowLink } from '../Common/Links';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import PageSection from './PageSection';
import * as styles from './WhyAttend.module.scss';

const WhyAttend = ({ section }) => {
  return (
    <PageSection noPad fullBleed data-analytics-section={'why-attend'}>
      <div className={styles.whyAttend}>
        <div className={styles.wordsContent}>
          <h2 className={styles.heading}>{section.heading}</h2>
          <RichTextConverter copy={section.sectionCopy} className={styles.paragraph} />
          {section.ctaLabel && <ArrowLink label={section.ctaLabel} url={section.ctaUrl} className={styles.arrowPink} />}
        </div>
        <div className={styles.insights}>
          {section.content.map((card) => (
            <div
              data-analytics-component={'why-attend-insight'}
              data-analytics-id={card.title}
              className={styles.insightsCard}
              key={card.id}
            >
              <hr />
              <span className={styles.numbers}>{card.title}</span>
              <RichTextConverter copy={card.body} className={styles.paragraph} />
            </div>
          ))}
        </div>
      </div>
    </PageSection>
  );
};

WhyAttend.propTypes = {
  section: PropTypes.object,
};

export default WhyAttend;
